import React from 'react'

class KingOfEth extends React.Component {
  render() {
    return (
      <a href="https://www.kingofeth.com" target="_blank">
        <nav className="panel">
          <div className="panel-block">
            <div className="columns">
              <div className="column logo-frame">
                <span className="logo-helper" />
                <img className="logo" src="/images/kingOfEthLogo.gif" role="presentation" />
              </div>
              <div className="column">
                <h2 className="title is-2">king of eth.</h2>
                <p>
                  A massively multiplayer decentralized boardgame built on Ethereum (of course).
                </p>
                <p>
                  Players collect resources of varying scarcity to build houses and roads on a seemingly ever-expanding board.
                </p>
                <p>
                  Depending on the locations of the structures the players build or the rarity of the resources they collect, players can build value through the various marketplaces the game provides.
                </p>
                <p>
                  There are also titles that players can attain for additional rewards, but they must compete against the other players to achieve them.
                </p>
                <p>
                  We believe that the seemingly-random nature of the board as well as an interesting process for increasing its size will make for a very interesting and very long (at least 19 years!) game.
                </p>
              </div>
            </div>
          </div>
        </nav>
      </a>
    )
  }
}

export default KingOfEth



// WEBPACK FOOTER //
// ./src/KingOfEth.js